@if (loading$ | async) {
  <div>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </div>
} @else {
  @if (templateList$ | async; as templateList) {
    <div class="cx-consent-toggles">
      <div class="col-sm-12 col-md-8 col-lg-6">
        @for (consentTemplate of templateList; track consentTemplate) {
          <app-efa-consent-management-form #test
            [consentTemplate]="consentTemplate"
            [requiredConsents]="requiredConsents"
          (consentChanged)="onConsentChange($event)"></app-efa-consent-management-form>
        }
      </div>
    </div>
  }
}

